import { FilterLabels } from './FilterLabels';
import { FilterValues } from './FilterValues';
import {
  All,
  Product,
  Discussion,
  Videos,
  Article,
  RealLifeStories,
} from './icons';

export const FILTER_OPTIONS = [
  { label: FilterLabels.ALL, value: FilterValues.ALL, icon: <All /> },
  {
    label: FilterLabels.ARTICLES,
    value: FilterValues.ARTICLE,
    icon: <Article />,
  },
  {
    label: FilterLabels.REAL_LIFE_STORIES,
    value: FilterValues.RLS,
    icon: <RealLifeStories />,
  },
  // {
  //   label: FilterLabels.PRODUCT,
  //   value: FilterValues.PRODUCT,
  //   icon: <Product />,
  // },
  // { label: FilterLabels.RESOURCE, value: FilterValues.RESOURCE, icon: '' },
  {
    label: FilterLabels.DISCUSSIONS,
    value: FilterValues.DISCUSSIONS,
    icon: <Discussion />,
  },
  { label: FilterLabels.VIDEOS, value: FilterValues.VIDEO, icon: <Videos /> },
];
